var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6863 24.5125L31.9279 29.7388C32.2198 30.0282 32.3839 30.4223 32.3839 30.8333C32.3839 31.2444 32.2198 31.6384 31.9279 31.9279C31.6384 32.2198 31.2444 32.3839 30.8333 32.3839C30.4223 32.3839 30.0282 32.2198 29.7388 31.9279L24.5125 26.6863C22.358 28.3774 19.6973 29.2951 16.9583 29.2917C10.1468 29.2917 4.625 23.7698 4.625 16.9583C4.625 10.1468 10.1468 4.625 16.9583 4.625C23.7698 4.625 29.2917 10.1468 29.2917 16.9583C29.2951 19.6973 28.3774 22.358 26.6863 24.5125ZM16.9583 7.70833C11.8497 7.70833 7.70833 11.8497 7.70833 16.9583C7.70833 22.067 11.8497 26.2083 16.9583 26.2083C22.067 26.2083 26.2083 22.067 26.2083 16.9583C26.2083 11.8497 22.067 7.70833 16.9583 7.70833Z",
    fill: "#006691"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchTab);
export default __webpack_public_path__ + "static/media/SearchTab.4c143009f0074471c786b0fbf0f0abd7.svg";
export { ForwardRef as ReactComponent };